import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import AppAvatar from '../app-avatar/AppAvatar';
import { useStyles } from './AppEntityAvatar.styles';
import theme from '../../../styles/theme';
import { useLazyGetDownloadURL } from '../../../services/redux/api/fireBaseStorageApi';
import { IAppFile } from '../../../types/interfaces/app-file';

export enum AvatarSize {
  s = 28,
  m = 40,
  l = 80,
  xl = 150,
}

interface Entity {
  firstname?: string;
  lastname?: string;
  name?: string;
  /** When entity uses avatar (IAppFile), links come from here */
  avatar?: IAppFile;
  /** Legacy: direct storage links on entity (prefer avatar) */
  previewStorageLink?: string;
  storageLink?: string;
  avatarPreviewStorageLink?: string;
  avatarStorageLink?: string;
}

interface AppEntityAvatarProps {
  fileBlob?: string;
  entity?: Entity;
  size?: AvatarSize;

  [key: string]: any;
}

export default function AppEntityAvatar(props: AppEntityAvatarProps) {
  const { fileBlob, entity, size = AvatarSize.m, ...avatarProps } = props;
  const [avatarSrc, setAvatarSrc] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [getFileUrl] = useLazyGetDownloadURL();

  const { classes } = useStyles(theme);

  function getStorageLink() {
    const file = entity?.avatar;
    if (file) {
      if (size === AvatarSize.s || size === AvatarSize.m) {
        return file.previewStorageLink || file.storageLink;
      }
      return file.storageLink;
    }
    if (size === AvatarSize.s || size === AvatarSize.m)
      return (
        entity?.previewStorageLink ||
        entity?.avatarPreviewStorageLink ||
        entity?.storageLink ||
        entity?.avatarStorageLink
      );
    return entity?.storageLink || entity?.avatarStorageLink;
  }

  useEffect(() => {
    if (fileBlob) {
      setAvatarSrc(fileBlob);
    } else if (getStorageLink()) {
      setIsLoading(true);

      getFileUrl(getStorageLink())
        .then((response) => setAvatarSrc(response.data))
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setAvatarSrc(null);
    }
  }, [fileBlob, entity]);

  function getName() {
    if (entity?.firstname || entity?.lastname) {
      return [entity?.firstname, entity?.lastname]
        .filter(Boolean)
        .map((i) => i![0])
        .join('');
    } else if (entity?.name) {
      return entity.name[0];
    }

    // return '!';
  }

  return (
    <div style={{ width: `${size}px`, height: `${size}px` }}>
      {isLoading ? (
        <div className={classes.loader}>
          <CircularProgress color="primary" />
        </div>
      ) : (
        <AppAvatar src={avatarSrc} size={size} {...avatarProps}>
          {getName()}
        </AppAvatar>
      )}
    </div>
  );
}
